import { ReactNode } from 'react'
import {
  Border,
  BoxConstraints,
  DrawOp,
  RenderBox,
  RenderBoxProvider,
  useRenderBox
} from '../rendering'

type Props = {
  backgroundColor?: string
  border?: Border
}

export class DecoratedRenderBox extends RenderBox<Props> {
  performLayout(constraints: BoxConstraints) {
    const child = this.children[0]

    if (child) {
      child.performLayout(constraints)
    }

    this.box = child
      ? { x: 0, y: 0, width: child.box.width, height: child.box.height }
      : { x: 0, y: 0, width: constraints.minWidth, height: constraints.minHeight }
  }

  draw(): DrawOp {
    const rect: DrawOp = {
      type: 'rect',
      id: `${this.id}_rect`,
      bounds: { x: 0, y: 0, width: this.box.width, height: this.box.height },
      border: this.props.border,
      background_color: this.props.backgroundColor
    }

    return {
      type: 'group',
      id: this.id,
      bounds: this.box,
      children: [rect, ...this.children.map((c) => c.draw())]
    }
  }
}

export function Decorated({ backgroundColor, border, children }: Props & { children?: ReactNode }) {
  const box = useRenderBox(
    () => new DecoratedRenderBox({ backgroundColor, border }),
    [backgroundColor, border?.color, border?.width, border?.radius]
  )
  return <RenderBoxProvider value={box}>{children}</RenderBoxProvider>
}
